import store from '../../store';

export default async (to, from, next) => {
    if (store.getters['authenticated']){
        next();
    } else {
        next({name: 'login-page'});
    }
}